import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class PurchaseConditionTargeting extends Component {

  configure() {
    return super.configure();
  }

  initialize() {

    this.addConditionButton = $('#addPurchaseCondition');
    this.template = $('.purchase-condition-template');
    this.removeConditionButtonSelector = '.is-delete-purchase-condition-button';

    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

    this.addConditionButton.on('click', (event) => {
      return this.onAddCondition(event);
    });

    $(document).on('click', this.removeConditionButtonSelector, (event) => {
      return this.onRemoveCondition(event);
    });
  }

  onAddCondition(event) {

    let cloned = this.template.children('.purchase-condition').clone(true, true);

    cloned.find('select[data-type=""]').parent().addClass('is-uni-select');
    cloned.find('select:not([data-type=""])').parent().addClass('is-select');
    this.template.before(cloned);

    this.App.Events.publish('form.refreshed', true);
    event.preventDefault();

  }

  onRemoveCondition(event) {

    $(event.currentTarget).closest('.purchase-condition').remove();

  }

}